import store from "@/store";
import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  { path: "/", name: "Login", component: () => import("../views/Login.vue") },
  { path: "/create_group", name: "CreateGroupForm", component: () => import("../views/CreateGroupForm.vue") },
  { path: "/create_group_job", name: "CreateGroupJobForm", component: () => import("../views/CreateGroupJobForm.vue") },
  { path: "/faq", name: "FAQ", component: () => import("../views/FAQ.vue") },
  { path: "/friend/:user_id?", name: "Friend", component: () => import("../views/Friend.vue") },
  { path: "/global_search_result", name: "GlobalSearchResult", props: true, component: () => import("../views/GlobalSearchResult.vue") },
  { path: "/group_detail/:group_id", name: "GroupDetail", component: () => import("../views/GroupDetail.vue") },
  { path: "/group_index", name: "GroupIndex", component: () => import("../views/GroupIndex.vue") },
  { path: "/group_job_detail/:job_id", name: "GroupJobDetail", component: () => import("../views/GroupJobDetail.vue") },
  { path: "/job_detail/:job_id", name: "JobDetail", component: () => import("../views/JobDetail.vue") },
  { path: "/job_index", name: "JobIndex", component: () => import("../views/JobIndex.vue") },
  { path: "/other_user_job_index/:user_id", name: "OtherUserJobIndex", component: () => import("../views/OtherUserJobIndex.vue") },
  { path: "/other_user_group_index/:user_id?", name: "OtherUserGroupIndex", component: () => import("../views/OtherUserGroupIndex.vue") },
  { path: "/other_user/:userId?", name: "OtherUser", component: () => import("../views/OtherUser.vue") },
  { path: "/top", name: "Top", component: () => import("../views/Top.vue") },
  { path: "/user/:user_id?", name: "User", component: () => import("../views/User.vue") }
];

const router = new VueRouter({ base: process.env.BASE_URL, mode: "history", routes });

router.beforeEach((to, from, next) => {
  store.commit("setLoading", true);
  next();
});

router.afterEach((to, from) => {
  if (from.name) store.commit("setLoading", false);
});

export default router;
